import type { AccountId } from '../generated-types';
import { useUpdateAccounts } from './useAccount';
import { useRefreshFuturePayments } from './useFuturePayments';
import { useInvalidateOutbox } from './useOutbox';
import { useRefreshPaymentItems } from './usePaymentItems';
import { useRefreshPaymentLimits } from './usePaymentLimits';
import { useUpdateTransactions } from './useTransactions';

export default () => {
    const updateAccounts = useUpdateAccounts();
    const updateFuturePayments = useRefreshFuturePayments();
    const refreshPaymentLimits = useRefreshPaymentLimits();
    const refreshTransactions = useUpdateTransactions();
    const refreshPayments = useRefreshPaymentItems();
    const outboxRefresh = useInvalidateOutbox();

    return (accountIds: AccountId[] = []) => {
        updateFuturePayments();
        updateAccounts(accountIds);
        refreshPaymentLimits();
        refreshTransactions(accountIds);
        refreshPayments();
        outboxRefresh();
    };
};
